export default __webpack_public_path__ + "static/media/abld_science.da3db18f6751613095861ca83a5754fc.svg";